/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterscurrency
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Currency" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersCurrency ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersCurrency extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Currency', [
            {
                character: '$',
                title: t('ab')
            },
            {
                character: '\u20AC',
                title: t('ac')
            },
            {
                character: '\xA5',
                title: t('ad')
            },
            {
                character: '\xA3',
                title: t('ae')
            },
            {
                character: '\xA2',
                title: t('af')
            },
            {
                character: '\u20A0',
                title: t('ag')
            },
            {
                character: '\u20A1',
                title: t('ah')
            },
            {
                character: '\u20A2',
                title: t('ai')
            },
            {
                character: '\u20A3',
                title: t('aj')
            },
            {
                character: '\u20A4',
                title: t('ak')
            },
            {
                character: '\xA4',
                title: t('al')
            },
            {
                character: '\u20BF',
                title: t('am')
            },
            {
                character: '\u20A5',
                title: t('an')
            },
            {
                character: '\u20A6',
                title: t('ao')
            },
            {
                character: '\u20A7',
                title: t('ap')
            },
            {
                character: '\u20A8',
                title: t('aq')
            },
            {
                character: '\u20A9',
                title: t('ar')
            },
            {
                character: '\u20AA',
                title: t('as')
            },
            {
                character: '\u20AB',
                title: t('at')
            },
            {
                character: '\u20AD',
                title: t('au')
            },
            {
                character: '\u20AE',
                title: t('av')
            },
            {
                character: '\u20AF',
                title: t('aw')
            },
            {
                character: '\u20B0',
                title: t('ax')
            },
            {
                character: '\u20B1',
                title: t('ay')
            },
            {
                character: '\u20B2',
                title: t('az')
            },
            {
                character: '\u20B3',
                title: t('ba')
            },
            {
                character: '\u20B4',
                title: t('bb')
            },
            {
                character: '\u20B5',
                title: t('bc')
            },
            {
                character: '\u20B6',
                title: t('bd')
            },
            {
                character: '\u20B7',
                title: t('be')
            },
            {
                character: '\u20B8',
                title: t('bf')
            },
            {
                character: '\u20B9',
                title: t('bg')
            },
            {
                character: '\u20BA',
                title: t('bh')
            },
            {
                character: '\u20BB',
                title: t('bi')
            },
            {
                character: '\u20BC',
                title: t('bj')
            },
            {
                character: '\u20BD',
                title: t('bk')
            }
        ]);
    }
}